import './Footer.css';

export const Footer = () => {
  return (
    <footer className="footer">
      <p>
        ©2023 - Made with ☕ and React by <span>Yuliia Harkusha</span>
      </p>
    </footer>
  );
};
